"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyDemandInclusionHistoryActionType = exports.UsStatesAndTerritoriesEnum = exports.UsTerritoriesEnum = exports.UsStatesEnum = exports.LeadFilterRuleType = void 0;
var LeadFilterRuleType;
(function (LeadFilterRuleType) {
    LeadFilterRuleType["ApprovalBiasedRuleCombinator"] = "approval_biased_rule_combinator";
    LeadFilterRuleType["RejectIfBooleanMatches"] = "reject_if_boolean_matches";
    LeadFilterRuleType["RejectIfGreaterThan"] = "reject_if_greater_than";
    LeadFilterRuleType["RejectIfInRange"] = "reject_if_in_range";
    LeadFilterRuleType["RejectIfInSet"] = "reject_if_in_set";
    LeadFilterRuleType["RejectIfLessThan"] = "reject_if_less_than";
    LeadFilterRuleType["RejectIfNotInSet"] = "reject_if_not_in_set";
    LeadFilterRuleType["RejectionBiasedRuleCombinator"] = "rejection_biased_rule_combinator";
})(LeadFilterRuleType || (exports.LeadFilterRuleType = LeadFilterRuleType = {}));
var UsStatesEnum;
(function (UsStatesEnum) {
    UsStatesEnum["AK"] = "Alaska";
    UsStatesEnum["AL"] = "Alabama";
    UsStatesEnum["AR"] = "Arkansas";
    UsStatesEnum["AZ"] = "Arizona";
    UsStatesEnum["CA"] = "California";
    UsStatesEnum["CO"] = "Colorado";
    UsStatesEnum["CT"] = "Connecticut";
    UsStatesEnum["DC"] = "District Of Columbia";
    UsStatesEnum["DE"] = "Delaware";
    UsStatesEnum["FL"] = "Florida";
    UsStatesEnum["GA"] = "Georgia";
    UsStatesEnum["HI"] = "Hawaii";
    UsStatesEnum["IA"] = "Iowa";
    UsStatesEnum["ID"] = "Idaho";
    UsStatesEnum["IL"] = "Illinois";
    UsStatesEnum["IN"] = "Indiana";
    UsStatesEnum["KS"] = "Kansas";
    UsStatesEnum["KY"] = "Kentucky";
    UsStatesEnum["LA"] = "Louisiana";
    UsStatesEnum["MA"] = "Massachusetts";
    UsStatesEnum["MD"] = "Maryland";
    UsStatesEnum["ME"] = "Maine";
    UsStatesEnum["MI"] = "Michigan";
    UsStatesEnum["MN"] = "Minnesota";
    UsStatesEnum["MO"] = "Missouri";
    UsStatesEnum["MS"] = "Mississippi";
    UsStatesEnum["MT"] = "Montana";
    UsStatesEnum["NC"] = "North Carolina";
    UsStatesEnum["ND"] = "North Dakota";
    UsStatesEnum["NE"] = "Nebraska";
    UsStatesEnum["NH"] = "New Hampshire";
    UsStatesEnum["NJ"] = "New Jersey";
    UsStatesEnum["NM"] = "New Mexico";
    UsStatesEnum["NV"] = "Nevada";
    UsStatesEnum["NY"] = "New York";
    UsStatesEnum["OH"] = "Ohio";
    UsStatesEnum["OK"] = "Oklahoma";
    UsStatesEnum["OR"] = "Oregon";
    UsStatesEnum["PA"] = "Pennsylvania";
    UsStatesEnum["RI"] = "Rhode Island";
    UsStatesEnum["SC"] = "South Carolina";
    UsStatesEnum["SD"] = "South Dakota";
    UsStatesEnum["TN"] = "Tennessee";
    UsStatesEnum["TX"] = "Texas";
    UsStatesEnum["UT"] = "Utah";
    UsStatesEnum["VA"] = "Virginia";
    UsStatesEnum["VT"] = "Vermont";
    UsStatesEnum["WA"] = "Washington";
    UsStatesEnum["WI"] = "Wisconsin";
    UsStatesEnum["WV"] = "West Virginia";
    UsStatesEnum["WY"] = "Wyoming";
})(UsStatesEnum || (exports.UsStatesEnum = UsStatesEnum = {}));
var UsTerritoriesEnum;
(function (UsTerritoriesEnum) {
    UsTerritoriesEnum["AS"] = "American Samoa";
    UsTerritoriesEnum["FM"] = "Federated States Of Micronesia";
    UsTerritoriesEnum["GU"] = "Guam";
    UsTerritoriesEnum["MH"] = "Marshall Islands";
    UsTerritoriesEnum["MP"] = "Northern Mariana Islands";
    UsTerritoriesEnum["PR"] = "Puerto Rico";
    UsTerritoriesEnum["PW"] = "Palau";
    UsTerritoriesEnum["VI"] = "Virgin Islands";
})(UsTerritoriesEnum || (exports.UsTerritoriesEnum = UsTerritoriesEnum = {}));
exports.UsStatesAndTerritoriesEnum = __assign(__assign({}, UsStatesEnum), UsTerritoriesEnum);
var SupplyDemandInclusionHistoryActionType;
(function (SupplyDemandInclusionHistoryActionType) {
    SupplyDemandInclusionHistoryActionType["Disabled"] = "Disabled";
    SupplyDemandInclusionHistoryActionType["Enabled"] = "Enabled";
})(SupplyDemandInclusionHistoryActionType || (exports.SupplyDemandInclusionHistoryActionType = SupplyDemandInclusionHistoryActionType = {}));
